import { FixMe } from '@utils/types';
import { get, set } from 'lodash';

const getPreRequisiteField = (field: FixMe) => {
  if (Array.isArray(field.preRequisiteField)) {
    return field.preRequisiteField;
  }
  return [field.preRequisiteField];
};

export const getFieldConfigs = (field: FixMe, formData: Record<string, string | undefined>) => {
  let forceDisabled = false;
  let preRequisiteValue;
  let preRequisiteObjectValue;

  if (field.preRequisiteField) {
    const preReqFields = getPreRequisiteField(field);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let index = 0; index < preReqFields.length; index++) {
      const f = preReqFields[index];
      if (
        (Object.prototype.hasOwnProperty.call(f, 'selectedValue') &&
          get(formData, f.name) !== f.selectedValue) ||
        (!Object.prototype.hasOwnProperty.call(f, 'selectedValue') && !get(formData, f.name))
      ) {
        /* disabledMode if true this field will appear as disabled
           until the preRequisiteField has a value
            if false or not set the field will not appear in the ui
            until the preRequisiteField has a value */
        // eslint-disable-next-line max-depth
        if (f.disabledMode) {
          forceDisabled = true;
        } else {
          return null;
        }
      }
    }

    // using only the first field if preRequisiteField is an array for reading value etc
    const preReqField = preReqFields[0];
    if (preReqField.includeValue) {
      preRequisiteValue = get(formData, preReqField.name);
    }
    const { includeToRequest } = field.preRequisiteField;
    if (includeToRequest) {
      if (typeof includeToRequest === 'boolean') {
        preRequisiteObjectValue = set({}, preReqField.name, preRequisiteValue);
      } else if (typeof includeToRequest === 'object' && includeToRequest?.transformKey) {
        preRequisiteObjectValue = set({}, includeToRequest.transformKey, preRequisiteValue);
      }
    }
  }
  if (field.readOnly) {
    forceDisabled = true;
  }

  return { forceDisabled, preRequisiteValue, preRequisiteObjectValue };
};
